export enum EUserType {
  Admin = "Admin",
  NotRegistered = "NotRegistered",
  Customer = "Customer",
  Business = "Business",
}

export enum EApprovalStatus {
  Pending = "Pending",
  Approved = "Approved",
  Blocked = "Blocked",
}

export enum EOrderStatus {
  New = "New",
  Accepted = "Accepted",
  InPreparation = "InPreparation",
  ReadyForPickup = "ReadyForPickup",
  CourierAssigned = "CourierAssigned",
  PickedUp = "PickedUp",
  Delivered = "Delivered",
  Cancelled = "Cancelled",
}

export enum EOrderType {
  Delivery = "Delivery",
  Pickup = "Pickup",
}

export enum EPaymentMethod {
  CreditCard = "CreditCard",
  Cash = "Cash",
}

export enum EPaymentStatus {
  Pending = "Pending",
  Paid = "Paid",
  Failed = "Failed",
  Refunded = "Refunded",
}

export enum EOperationStatus {
  Regular = "Regular",
  ManuallyClosed = "ManuallyClosed",
  PausedOrders = "PausedOrders",
}

export enum EKosherStatus {
  Kosher = "Kosher",
  KosherLeMehadrin = "KosherLeMehadrin",
  Badatz = "Badatz",
  MehadrinMinHaMehadrin = "MehadrinMinHaMehadrin",
  Rabbanut = "Rabbanut",
  RabbanutMehadrin = "RabbanutMehadrin",
  NotKosher = "NotKosher",
  None = "None",
}

export enum ELanguage {
  Hebrew = "he",
  English = "en",
}

export enum EPlatform {
  AdminPanel = "AdminPanel",
  App = "App",
  Web = "Web",
}

export enum EBusinessContactType {
  WhatsApp = "WhatsApp",
  Phone = "Phone",
  Email = "Email",
}
